import { reduxForm, formValueSelector } from 'redux-form';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { navigateToScreen } from 'actionCreators/navigation';
import { onSubmit, onSubmitSuccess, onSubmitFail } from './Home.submit';
import { validate } from './Home.validate';
import { HomeScreen } from './HomeScreen';

const HomeForm = reduxForm({
  form: 'Home',
  onSubmit,
  onSubmitSuccess,
  validate,
  onSubmitFail,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(HomeScreen);

const selector = formValueSelector('Home');

const HomeContainer = connect(
  (state) => ({
    isLoading: state.loader.isLoading,
    accountValue: selector(state, 'account')
  }),
  (dispatch) => bindActionCreators({ navigateToScreen }, dispatch)
)(HomeForm);

export { HomeContainer };
